export const ADD_STUDENT = "ADD_STUDENT"
export const SET_ACTIVE_STUDENT = "SET_ACTIVE_STUDENT"
